class NewsletterForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.endpoint =
      'https://op-newsletter-form.by-association-only.workers.dev/signup'

    this.setupCountryCode()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handlePhoneInput = this.handlePhoneInput.bind(this)

    if (this.els.form?.exists) {
      this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
    }

    if (!this.els.phone?.exists) return

    this.listeners.add(
      this.els.phone.element,
      'countrychange',
      this.handlePhoneInput,
    )

    this.listeners.add(this.els.phone.element, 'change', this.handlePhoneInput)
    this.listeners.add(this.els.phone.element, 'input', this.handlePhoneInput)
  }

  setupCountryCode () {
    if (!this.els.phone?.exists) return
    if (!window.intlTelInput) return

    this.iti = window.intlTelInput(this.els.phone.element, {
      utilsScript:
        'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
      separateDialCode: true,
      showFlags: false,
      initialCountry: this.dataset.initialCountry || 'gb',
      strictMode: true,
    })
  }

  async handleSubmit (event) {
    event.preventDefault()

    await this.handlePhoneInput()

    try {
      const response = await this.submitForm(this.formData)

      if (response.success) {
        this.showSuccess()
      } else {
        this.showError(
          response.error ||
            response.message ||
            'Submission failed. Please try again.',
        )
      }
    } catch (error) {
      console.error('Form submission error:', error)

      this.showError('An unexpected error occurred. Please try again later.')
    }
  }

  async handlePhoneInput () {
    if (!this.els.phoneFormatted?.exists) return

    this.els.phoneFormatted.element.value =
      this.iti?.getNumber() || this.els.phone.element.value
  }

  async submitForm (data) {
    try {
      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })

      const responseData = await response.json()

      if (!response.ok) {
        console.error(`API Error: ${response.status}`, responseData)
      }

      return responseData
    } catch (error) {
      console.error('Fetch or JSON parsing failed:', error)

      return {
        success: false,
        message: 'Network error or invalid response from server.',
      }
    }
  }

  showSuccess () {
    this.els.form?.element?.reset()

    this.innerHTML = `
      <div
        class="frm-Form_Validation"
        tabindex="-1"
        role="status"
      >
        <p class="frm-Form_ValidationText frm-Form_ValidationText-success">
          ${this.dataset.successMessage || "You're signed up"}
        </p>
      </div>
    `

    this.querySelector('.frm-Form_Validation')?.focus()
  }

  showError (message) {
    let errorContainer = this.querySelector('.frm-Form_Validation')

    if (!errorContainer) {
      errorContainer = document.createElement('div')

      errorContainer.className = 'frm-Form_Validation'
      errorContainer.setAttribute('tabindex', '-1')
      errorContainer.setAttribute('role', 'alert')

      errorContainer.innerHTML = `
        <p class="frm-Form_ValidationText frm-Form_ValidationText-error"></p>
      `

      this.prepend(errorContainer)
    }

    errorContainer.querySelector('.frm-Form_ValidationText').textContent =
      message

    errorContainer.focus()
  }

  get smsConsent () {
    if (!this.els.gdpr?.exists) return false

    return this.els.gdpr.element.checked
  }

  get phone () {
    const phone = this.iti?.getNumber() || this.els.phone?.element?.value || ''

    /**
     * Footer form has no GDPR/SMS checkbox, so still send the phone.
     * Standalone form has GDPR checkbox, so only send phone when checked.
     */
    if (!this.els.gdpr?.exists) return phone

    return this.smsConsent ? phone : ''
  }

  get formData () {
    return {
      firstName: this.els.firstname?.element?.value || '',
      lastName: this.els.lastname?.element?.value || '',
      email: this.els.email.element.value,
      phone: this.phone,
      sms_consent: this.els.gdpr?.exists
        ? this.smsConsent
        : Boolean(this.phone),
      source: this.dataset.source,
      store: this.dataset.store,
    }
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm)
}
